"use client"
import { usePathname } from "next/navigation"
import { useIsMobile } from "@/hooks/use-mobile"

// 需要隐藏 Header 的路径
const HIDE_HEADER_PATHS = ["/thirdMd", "/third-callback"]
const HIDE_HEADER_MOBILE_PATHS = ["/order/"]

export function HeaderWrapper({ children }: { children: React.ReactNode }) {
	const isMobile = useIsMobile()
	const pathname = usePathname()
	// 如果是多语言路由，处理 locale 前缀
	const path = pathname.replace(/^\/[a-zA-Z-]+/, "")
	if (HIDE_HEADER_PATHS.some((p) => path.startsWith(p))) {
		return null
	}
	if (isMobile && HIDE_HEADER_MOBILE_PATHS.some((p) => path.startsWith(p))) {
		return null
	}
	return <>{children}</>
}
